module.exports = __webpack_public_path__ + "static/img/active-3.3568423.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background_clinic/active-3.jpg
// module id = TRFP
// module chunks = 1